export default __webpack_public_path__ + "static/media/filter.8597bd89.svg";